import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@material-ui/core';
import IframeResizer from 'iframe-resizer-react';

import useStyles from './useStyles';
import { WALL_OF_LOVE_ROUTE } from '../../../../constants';
import { Button } from '../../../../components';
import { LandingContext } from '../../../../context/landing';

export const WallOfLoveSection = () => {
  const { landingData } = useContext(LandingContext);

  const classes = useStyles();
  const { testimonialsSection = {} } = landingData;
  const {
    show = false,
    title,
    buttonText = '',
    urlWidget = '',
    starsWidget = '',
  } = testimonialsSection;

  if (!show) {
    return null;
  }

  return (
    <section id="testimonials" className={classes.container}>
      <Typography className={classes.title} component="h2">
        {title}
      </Typography>
      {
        urlWidget && (
        <IframeResizer
          src={urlWidget}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
        )
      }
      {
        starsWidget && (
          <IframeResizer
            src={starsWidget}
            style={{
              width: '100%',
              height: '100%',
              border: 'none',
            }}
          />
        )
      }

      <Box className={classes.buttonContainer}>
        <Link
          to={WALL_OF_LOVE_ROUTE}
          target="_blank"
        >
          <Button className={classes.customButton}>
            {buttonText}
          </Button>
        </Link>
      </Box>
    </section>
  );
};
